import { useEffect, useState } from "react";


const RemitaSummary = () => {
  const data = JSON.parse(localStorage.getItem("remitaData") || "{}");

  if (!data?.rrr) {
    return <p>No Remita data available</p>;
  }

  const handleProceed = () => {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = data.paymentUrl;
    form.style.display = "none";

    const fields = {
      merchantId: data.merchantId,
      serviceTypeId: data.serviceTypeId,
      orderId: data.orderId,
      amount: data.amount,
      apiKey: data.apiKey,
    };

    Object.entries(fields).forEach(([key, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Remita Payment Summary</h2>

      <p><b>Name:</b> {data.name}</p>
      <p><b>Email:</b> {data.email}</p>
      <p><b>Phone:</b> {data.phone}</p>
      <p><b>Amount:</b> ₦{data.amount}</p>

      <hr />

      <h3>RRR: {data.rrr}</h3>

      <button onClick={handleProceed}>
        Proceed to Pay
      </button>
    </div>
  );
};


export default RemitaSummary;